export enum LabelSearchEnum {
    Option = 'Opção',
    Future = 'Futuro',
    Stock = 'Ação',
    FutureStock = 'Futuro de Ação'
}